var _linearGradient, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274.816,
    height: 87.445,
    viewBox: "0 0 274.816 87.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93467",
    "data-name": "Path 93467",
    d: "M-1045.016,1981.142v45.717h-274.816v-45.717s12.371-32.722,81.075-32.722S-1045.016,1981.142-1045.016,1981.142Z",
    transform: "translate(1319.832 -1948.42)",
    fill: "#1e3e92",
    opacity: 0.43,
    style: {
      isolation: "isolate"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.868,
    y1: 0.959,
    x2: 0.053,
    y2: -0.057,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.637,
    cy: 0.484,
    r: 1.003,
    gradientTransform: "translate(0.191) scale(0.618 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#382879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#3a156a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#3c0961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#360965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#2a0f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#271273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#2d0e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#390862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#220336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#09000f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.621,
    cy: 0.579,
    r: 0.662,
    gradientTransform: "translate(0.202) scale(0.596 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#42e2de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#41d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3eb6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#3b90c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#3760ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#3759ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#386ab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3eadcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#41d7db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#3dd4cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#2da0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#1b6269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#1d6c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#278d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#30a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#37c0bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#3cd2cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#40ded8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#42e5df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#41e2db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#35b8b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#2a9290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#217372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#195a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#144648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#10383a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#0d3033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#0d2e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#0f4446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#126968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#158784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#179f9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "#18afa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#19b9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#1abdb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#020708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.389,
    cy: 0.786,
    r: 0.662,
    gradientTransform: "translate(0.202) scale(0.596 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#330550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#1d022d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#0d0114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#030005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#1bb0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#1b88b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#1b2b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#162357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#0f183c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#090f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#050814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#020308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(0.231 -0.154) rotate(22.637)",
    xlinkHref: "#radial-gradient-4"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.148, 0.989, -0.989, 0.148, 0.92, -0.069)",
    xlinkHref: "#radial-gradient-4"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#2e66bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#1b2b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#162357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#0f183c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#090f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#050814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#020308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-16"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46337",
    "data-name": "Group 46337",
    transform: "translate(0 -9769.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93466",
    "data-name": "Path 93466",
    d: "M328.056-397.549v60.344H56.328V-387.2s14.16-37.451,92.8-37.451c51.4,0,130.337,16,178.86,27.085C328.008-397.561,328.031-397.555,328.056-397.549Z",
    transform: "translate(-53.239 10193.72)",
    fill: "#262bdb",
    opacity: 0.23,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_166",
    "data-name": "Mask Group 166",
    transform: "translate(0 9778.075)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    transform: "translate(274.816 109.546) rotate(180)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 276.124,
    height: 125.895,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M189.5,83.7l-6.772.831-6.3-2.916,2.269-3.963,4.277-.525,4.272-.524,2.254,1.043v-.124l-2.116-.979,2.116-3.7v-.4l-6.193-2.867,1.132-1.977,1.134-1.98,3.927-.482v-.088l-3.972.487-6.3-2.914L181.5,58.66l4.277-.525,3.722-.457v-.086l-3.769.462-4.272.524-6.283-2.908,2.266-3.957,8.56-1.05,3.5,1.619v-.124L186.135,50.6l2.266-3.957,1.1-.135v-.1l-1.168.143-6.274-2.9,2.269-3.963,4.277-.525.9-.11v-.086l-.944.116-4.271.524-6.283-2.908,2.266-3.958,8.56-1.05L189.5,32v-.124l-.542-.251.542-.947V30.3l-.738,1.29-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.283-.525,4.744,2.2V26.8l-4.617-2.137,2.3-4.011-6.443-2.982-8.666,1.063-6.274-2.9,2.3-4.011-6.443-2.982L152.987,9.9l-6.282-2.908L149,2.982,142.559,0l-8.766,1.075-2.3,4.009-8.66,1.063-2.3,4.009-8.66,1.063-2.3,4.009-8.66,1.063L98.63,20.3l-8.66,1.063-2.3,4.009-8.66,1.063-2.3,4.009L68.058,31.5l-2.3,4.009L57.1,36.575l-2.3,4.009-8.66,1.063-2.3,4.009L35.19,46.718l-2.3,4.009-8.66,1.063L21.94,55.8l-8.661,1.063-2.3,4.009-8.66,1.063L0,65.989l6.369,2.948-2.3,4.011,6.443,2.982,8.666-1.063,6.282,2.908-2.3,4.011,6.443,2.982,8.666-1.064,6.275,2.9-2.3,4.012L48.7,93.6l8.666-1.063L60.4,93.949h.253l-3.167-1.466,2.269-3.963,8.561-1.05,6.274,2.9-2.047,3.574h.191L74.771,90.4l4.277-.525,4.272-.524L89.6,92.255l-.97,1.694h.213l.954-1.665,8.56-1.05,5.866,2.715h.267l-6-2.779,2.266-3.957,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-3.22.395h.7l2.565-.314,4.271-.524,1.812.839h.268l-1.942-.9,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918-1.133,1.977-.581,1.015h.186l.569-.993,1.134-1.98,8.56-1.05,6.3,2.914-.635,1.109h.191l.623-1.088,4.277-.525,4.272-.524L159,93.949h.268l-4.746-2.2,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918-2.267,3.96-2.691.33h.7l2.136-.262,2.3-4.009,8.661-1.063,2.3-4.009,6.731-.826Zm-13.251-2.106-4.277.525-4.271.524-6.3-2.918,1.132-1.977,1.134-1.98,8.56-1.05,6.3,2.914ZM110.284,56.183l-2.269,3.962-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05Zm-6.145-2.968,2.266-3.958,8.56-1.05,6.275,2.9-2.269,3.962-4.278.525-4.271.524Zm6.324,2.989,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.561,1.05-6.274-2.9Zm15.028,1.888,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.271.524-6.283-2.908Zm8.493-1.143L125.425,58l-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908ZM129.927,50l-4.277.525-4.272.524L115.1,48.144l2.266-3.958,8.56-1.05,6.275,2.9Zm-3.876-6.931,2.266-3.958,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.272.524Zm10.76-5.1-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-8.69,1.114-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524Zm-10.956,5.071L114.9,48.115l-8.561,1.05-6.274-2.9,2.269-3.963,4.278-.525,4.271-.524Zm-10.956,5.071-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM95.253,54.3l-2.266,3.958-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524ZM84.3,59.371l-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM73.342,64.443,71.076,68.4l-8.561,1.05-6.274-2.9,2.269-3.962,4.278-.525,4.271-.524Zm.2.029,8.56-1.05,6.274,2.9L86.1,70.288l-4.277.525-4.272.524-6.283-2.908Zm8.69-1.114L84.494,59.4l8.561-1.05,6.274,2.9L97.06,65.217l-4.277.525-4.271.524Zm17.28-2.082,4.278-.525,4.271-.524,6.283,2.908-2.266,3.957-8.56,1.05-6.274-2.9Zm15.028,1.888,8.56-1.05,6.274,2.9L127.1,68.98l-4.277.525-4.272.524-6.283-2.908Zm15.014,1.875,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.561,1.05L127.281,69Zm8.687-1.109,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.05Zm10.777-5.092-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.274,2.9Zm-4.072-6.96-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-3.879-6.925,2.269-3.962,4.277-.525,4.272-.524,6.283,2.908L155.9,46.807l-8.56,1.05Zm10.777-5.092-4.277.525-4.272.524L137.007,38l2.266-3.958,8.56-1.05,6.275,2.9Zm-4.072-6.96-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525L135.159,27l-6.29-2.912,2.266-3.957,8.56-1.05,6.282,2.908Zm-8.687,1.109-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.561-1.05Zm-10.956,5.071L121.8,36.1l-4.277.525-4.272.524-6.29-2.912,2.266-3.958,8.56-1.05ZM113.11,37.205l-2.269,3.963-4.277.525-4.272.524L96,39.305l2.266-3.957,8.561-1.051Zm-10.956,5.071-2.269,3.963-4.277.525-4.271.524-6.29-2.912,2.266-3.958,8.56-1.05ZM91.2,47.348l-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.561-1.05ZM80.242,52.42l-2.269,3.963-4.277.525-4.271.524-6.29-2.912L65.4,50.562l8.56-1.051ZM69.286,57.491l-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.958L63,54.583ZM58.33,62.562l-2.269,3.962-4.277.525-4.271.524-6.29-2.912L43.488,60.7l8.56-1.05ZM47.554,67.654l4.277-.525,4.272-.524,6.283,2.908L60.12,73.471l-8.56,1.05-6.275-2.9Zm15.028,1.888,8.561-1.05,6.274,2.9L75.148,75.36l-4.277.525-4.271.524L60.316,73.5ZM77.6,71.418l4.278-.525,4.271-.524,6.283,2.908-2.266,3.957L81.6,78.285l-6.274-2.9Zm8.687-1.109,2.269-3.963,4.277-.525L97.1,65.3l6.283,2.908-2.266,3.957-8.56,1.05Zm17.3-2.074,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525L107.6,75.1l-6.283-2.909Zm15.014,1.875,4.277-.525,4.272-.524,6.283,2.908-2.265,3.957-8.561,1.05-6.274-2.9ZM133.622,72l8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.272.524-6.283-2.908Zm8.69-1.114,2.266-3.957,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.271.524Zm17.28-2.082,4.277-.525,4.272-.524,6.3,2.918-1.132,1.977-1.134,1.98-8.56,1.05-6.3-2.914Zm8.508-1.13-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.56-1.05,6.274,2.9Zm-4.072-6.96-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525-4.272.524-6.283-2.908L147.4,47.95l8.56-1.05,6.275,2.9Zm-3.876-6.931,2.266-3.958,8.56-1.05,6.274,2.9-2.269,3.963-4.277.525-4.272.524Zm10.759-5.1-8.56,1.05-6.275-2.9,2.269-3.962,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.56-1.05,6.275,2.9Zm-4.072-6.96-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525-4.272.524-6.29-2.912,2.266-3.958,8.561-1.05,6.282,2.908Zm-15.028-1.888-8.561,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524,6.29,2.912Zm-8.69,1.114-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.278-.525,4.271-.524ZM119.99,25.18l-2.266,3.957-8.561,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524Zm-10.956,5.071-2.266,3.958-8.56,1.05-6.282-2.908,2.269-3.963,4.278-.525,4.272-.524ZM98.079,35.322,95.813,39.28l-8.561,1.05L80.97,37.422l2.269-3.963,4.277-.525,4.272-.524ZM87.123,40.394l-2.266,3.957L76.3,45.4l-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM76.167,45.465,73.9,49.422l-8.561,1.05-6.282-2.908L61.327,43.6l4.277-.525,4.272-.524ZM65.211,50.536l-2.266,3.957-8.56,1.05L48.1,52.636l2.269-3.963,4.277-.525,4.271-.524ZM54.255,55.608l-2.266,3.957-8.561,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM43.3,60.679l-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.271-.524ZM32.344,65.75l-2.266,3.957-8.561,1.05L15.235,67.85,17.5,63.887l4.277-.525,4.272-.524Zm.188.025,8.561-1.05,6.282,2.908L45.106,71.6l-4.277.525-4.272.524-6.29-2.912Zm4.066,6.95,4.277-.525,4.271-.524,6.283,2.908-2.266,3.958L40.6,79.593l-6.274-2.9Zm15.028,1.888,8.56-1.05,6.275,2.9-2.269,3.962-4.277.525-4.272.524L49.36,78.572ZM66.64,76.489l4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.05-6.275-2.9Zm15.028,1.888,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524L79.4,82.335Zm8.69-1.114,2.266-3.958,8.56-1.05,6.274,2.9-2.269,3.963-4.277.525-4.272.524Zm17.28-2.082,4.277-.525,4.271-.524,6.283,2.908L120.2,81l-8.561,1.05-6.274-2.9Zm15.028,1.888,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524L120.4,81.027Zm15.014,1.875,4.277-.525,4.272-.524,6.3,2.918L151.4,82.792l-1.133,1.98-8.561,1.05-6.3-2.914Zm8.687-1.109,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918-1.132,1.977-1.134,1.98-8.56,1.05Zm43.109-5.282-2.269,3.963-4.277.525-4.272.524-6.3-2.918,1.133-1.978,1.134-1.98,8.56-1.05ZM185.4,65.6l-1.132,1.977-1.134,1.98-8.56,1.05-6.3-2.914,2.269-3.963,4.277-.525,4.272-.524Zm-4.076-6.962L179.056,62.6l-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.56-1.05Zm-6.341-3-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm13.221-9.029-2.266,3.957-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524Zm-4.055-6.952-2.269,3.963-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05Zm-4.075-6.954-2.266,3.958-8.56,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524Zm-6.324-2.989-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.56-1.05,6.274,2.9Zm-1.6-10.9,8.537-1.047,6.3,2.914-2.27,3.965-4.283.526-4.272.524-6.283-2.908Zm-.2-.018-2.269,3.963-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.283-.526ZM153.053,9.98,161.6,8.931l6.3,2.914-2.27,3.965-4.283.525-4.272.524-6.29-2.912Zm-.192-.02-2.269,3.963-8.56,1.05-6.282-2.908L138.018,8.1l4.278-.525,4.283-.526ZM133.94,1.143,142.506.093l6.3,2.914-2.271,3.965-4.283.525-4.272.524-6.3-2.918ZM122.984,6.215l8.555-1.049,6.3,2.916-2.269,3.963-4.278.525-4.271.524-6.3-2.918Zm-10.956,5.071,8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918Zm-10.956,5.071,8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.271.524-6.3-2.918ZM90.117,21.429l8.555-1.049,6.3,2.916L102.7,27.258l-4.277.525-4.272.524-6.3-2.918ZM79.161,26.5l8.555-1.049,6.3,2.916L91.747,32.33l-4.277.525-4.272.524-6.3-2.918ZM68.205,31.572l8.555-1.049,6.3,2.916L80.791,37.4l-4.277.525-4.272.524-6.3-2.918ZM57.249,36.643,65.8,35.594l6.3,2.916-2.269,3.963L65.558,43l-4.271.524-6.3-2.918ZM46.294,41.714l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM35.338,46.786l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM24.382,51.857l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM13.426,56.929l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM.2,65.965,2.47,62l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525L6.5,68.879Zm18.916,8.826-8.548,1.048-6.3-2.914,2.27-3.965,4.283-.526L15.1,67.91l6.29,2.912Zm.192.019,2.269-3.963,8.56-1.05,6.282,2.908L34.15,76.668l-4.277.525-4.283.525ZM38.2,83.63l-8.537,1.047-6.3-2.914L25.637,77.8l4.283-.526,4.272-.524,6.283,2.908Zm.2.018,2.269-3.963,8.561-1.05,6.274,2.9L53.236,85.5l-4.277.525-4.283.525Zm18.884,8.817-8.537,1.047-6.3-2.914,2.271-3.965,4.283-.526,4.272-.524,6.283,2.908Zm10.965-5.087-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm15.028,1.888L79,89.791l-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.274,2.9Zm15.014,1.875-8.56,1.05-6.275-2.9,2.269-3.963L90,84.8l4.271-.524,6.283,2.908Zm10.956-5.071-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm15.028,1.888L120,88.483l-4.272.524L109.445,86.1l2.266-3.957,8.56-1.05,6.274,2.9Zm15.035,1.885-8.56,1.05-6.3-2.914,2.269-3.963L131,83.492l4.271-.524,6.3,2.918-1.132,1.977Zm15.028,1.888-4.277.525-4.271.524-6.3-2.918,1.132-1.977,1.134-1.98,8.56-1.05,6.3,2.914ZM165.3,86.66l-4.277.525-4.272.524-6.3-2.918,1.133-1.977,1.134-1.98,8.56-1.05,6.3,2.914Zm15.034,1.887-8.555,1.05-6.3-2.916,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918Z",
    transform: "translate(74.174 23.195)",
    opacity: 0.7,
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M193,80.482l-1.715,3-8.555,1.049-6.3-2.916,2.269-3.963,4.278-.525,4.271-.524L193,79.261v-.124l-5.613-2.6,2.269-3.963,3.345-.41V72.08l-3.386.415-6.3-2.918,1.132-1.977,1.134-1.98L193,64.709V64.62l-7.47.916-6.3-2.914L181.5,58.66l4.277-.525,4.271-.524L193,58.976v-.124l-2.81-1.3,2.269-3.963.541-.066v-.086l-.582.071L186.135,50.6l2.266-3.958,4.6-.564v-.1l-4.666.573-6.274-2.9,2.269-3.962,4.277-.525,4.272-.524.122.056v-.423l-.163.286-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05L193,33.615v-.124l-4.039-1.87,2.275-3.973L193,27.432v-.086l-1.84.226-6.274-2.9,2.3-4.012-6.443-2.982-8.666,1.063-6.275-2.9,2.3-4.011-6.443-2.982L152.987,9.9l-6.282-2.908L149,2.982,142.559,0l-8.766,1.075-2.3,4.009-8.66,1.063-2.3,4.009-8.66,1.062-2.3,4.009-8.66,1.063L98.63,20.3l-8.66,1.063-2.3,4.009-8.66,1.063-2.3,4.009L68.058,31.5l-2.3,4.009L57.1,36.575l-2.3,4.009-8.661,1.063-2.3,4.009-8.66,1.063-2.3,4.009-8.661,1.063L21.94,55.8l-8.66,1.063-2.3,4.009L2.323,61.932,0,65.99l6.369,2.948-2.3,4.011,6.443,2.982,8.666-1.063,6.282,2.908-2.3,4.011,6.443,2.982,8.666-1.063,6.275,2.9-2.3,4.011L45.8,92.267h.253L42.452,90.6l2.271-3.965,4.283-.526,4.272-.524,6.283,2.908L57.4,92.267h.213l2.145-3.746,8.561-1.05,6.274,2.9-1.083,1.892H73.7L74.771,90.4l4.277-.525,4.272-.524L89.6,92.255l-.007.012h.343l8.42-1.033,2.231,1.033h.268l-2.37-1.1,2.266-3.957,8.561-1.05,6.274,2.9-1.832,3.2h.191l1.82-3.179,4.277-.525,4.272-.524,6.3,2.918-.75,1.31h.186l.739-1.29,8.56-1.05,5.057,2.341h.268l-5.195-2.4,1.132-1.977,1.134-1.98,8.561-1.05,6.3,2.914-2.269,3.963-4.277.525-.086.011h.7l3.7-.454.981.454h.267l-1.111-.514,2.269-3.963,4.278-.525,4.271-.524,6.3,2.918-1.493,2.608h.186l1.482-2.588,8.66-1.063,2.3-4.009,8.661-1.063L193,80.806Zm-16.748,1.107-4.278.525-4.271.524-6.3-2.918,1.132-1.977,1.134-1.98,8.561-1.05,6.3,2.914ZM121.24,51.112l-2.269,3.963-4.278.525-4.271.524-6.283-2.908,2.266-3.958,8.561-1.05ZM115.1,48.144l2.266-3.957,8.56-1.05,6.275,2.9L129.927,50l-4.277.525-4.272.524Zm-4.811,8.04-2.269,3.963-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.56-1.05Zm.179.021,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.051-6.275-2.9Zm8.687-1.109,2.269-3.963,4.277-.525,4.271-.524,6.283,2.908-2.266,3.958L125.425,58Zm10.956-5.072,2.269-3.962,4.277-.525,4.272-.524,6.283,2.908-2.266,3.958-8.56,1.05Zm10.777-5.092-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.561-1.05,6.274,2.9Zm-4.072-6.96-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.271-.524,6.283,2.908Zm-8.69,1.114-2.266,3.958-8.56,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524Zm-10.956,5.072L114.9,48.115l-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.271-.524Zm-10.956,5.071-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM95.253,54.3l-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM84.3,59.371l-2.266,3.957-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM73.342,64.443,71.076,68.4l-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524Zm.2.029,8.56-1.05,6.275,2.9L86.1,70.288l-4.277.525-4.272.524-6.283-2.908Zm8.69-1.114L84.494,59.4l8.561-1.05,6.274,2.9L97.06,65.217l-4.277.525-4.272.524Zm17.28-2.082,4.277-.525,4.272-.524,6.283,2.908-2.266,3.958-8.561,1.05-6.274-2.9Zm15.028,1.888,8.56-1.05,6.274,2.9L127.1,68.981l-4.277.525-4.272.524-6.283-2.908Zm8.69-1.114,2.266-3.958,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524Zm17.28-2.082,4.278-.525,4.271-.524,6.283,2.908-2.266,3.958-8.561,1.05-6.274-2.9Zm8.508-1.13-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm-3.876-6.931L147.4,47.95l8.561-1.05,6.274,2.9-2.269,3.962-4.277.525-4.272.524Zm10.76-5.1-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.271-.524,6.283,2.908Zm-4.058-6.947-4.277.525-4.272.524L137.007,38l2.266-3.957,8.56-1.05,6.275,2.9Zm-4.072-6.96-8.56,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525L135.159,27l-6.29-2.912,2.266-3.957,8.56-1.05,6.282,2.908Zm-8.687,1.109-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.56-1.05Zm-10.956,5.071L121.8,36.1l-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.56-1.05ZM113.11,37.205l-2.269,3.963-4.277.525-4.272.524L96,39.305l2.266-3.957,8.56-1.05Zm-10.956,5.071-2.269,3.963-4.278.525-4.271.524-6.29-2.912,2.266-3.957,8.56-1.05ZM91.2,47.348l-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.561-1.05ZM80.242,52.42l-2.269,3.963-4.277.525-4.272.524-6.29-2.912L65.4,50.562l8.56-1.05ZM69.286,57.491l-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957L63,54.583ZM58.33,62.562l-2.269,3.963-4.277.525-4.272.524-6.29-2.912L43.488,60.7l8.561-1.05ZM47.554,67.655l4.277-.525,4.272-.524,6.283,2.908L60.12,73.471l-8.56,1.05-6.274-2.9Zm15.028,1.888,8.561-1.05,6.274,2.9L75.148,75.36l-4.277.525-4.272.524L60.316,73.5ZM77.6,71.418l4.277-.525,4.272-.524,6.283,2.908-2.266,3.957L81.6,78.285l-6.274-2.9Zm8.687-1.109,2.269-3.963,4.277-.525L97.1,65.3l6.283,2.908-2.266,3.958-8.56,1.05Zm17.3-2.074,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525L107.6,75.1l-6.283-2.908Zm15.014,1.875,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.561,1.05-6.274-2.9ZM127.281,69l2.269-3.963,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.05Zm17.3-2.074,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524-6.283-2.908ZM159.592,68.8l4.278-.525,4.271-.524,6.3,2.918-1.132,1.977-1.134,1.98-8.561,1.05-6.3-2.914Zm8.508-1.13-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm-4.072-6.959-8.56,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-3.879-6.926,2.269-3.963L166.7,49.3l4.271-.524,6.283,2.908-2.266,3.957-8.561,1.05Zm10.777-5.092-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm-4.072-6.959-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.278.525-4.271.524-6.283-2.908,2.266-3.957,8.561-1.05,6.274,2.9Zm-3.876-6.931,2.266-3.957,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.272.524Zm-.2-.029-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.561-1.05,6.282,2.908Zm-15.028-1.888-8.561,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524,6.29,2.912Zm-8.69,1.114-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM119.99,25.18l-2.266,3.957-8.561,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524Zm-10.956,5.071-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM98.079,35.322,95.813,39.28l-8.561,1.05L80.97,37.422l2.269-3.963,4.277-.525,4.272-.524ZM87.123,40.394l-2.266,3.957L76.3,45.4l-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM76.167,45.465,73.9,49.422l-8.56,1.05-6.282-2.908L61.327,43.6l4.277-.525,4.272-.524ZM65.211,50.536l-2.266,3.957-8.56,1.05L48.1,52.636l2.269-3.963,4.277-.525,4.271-.524ZM54.255,55.608l-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM43.3,60.679l-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.271-.524ZM32.344,65.751l-2.266,3.957-8.561,1.05L15.235,67.85,17.5,63.888l4.277-.525,4.272-.524Zm.189.025,8.56-1.05,6.282,2.908L45.106,71.6l-4.277.525-4.272.524-6.29-2.912Zm4.066,6.95,4.277-.525,4.272-.524,6.283,2.908-2.266,3.958L40.6,79.593l-6.274-2.9Zm15.028,1.888,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.272.524L49.36,78.572ZM66.64,76.489l4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.05-6.274-2.9Zm15.028,1.888,8.56-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524L79.4,82.335Zm8.69-1.114,2.266-3.958,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.272.524Zm17.28-2.082,4.277-.525,4.272-.524,6.283,2.908L120.2,81l-8.56,1.05-6.275-2.9Zm15.028,1.888,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524L120.4,81.027Zm8.69-1.114L133.622,72l8.56-1.05,6.274,2.9-2.269,3.963-4.277.525-4.272.524Zm17.28-2.082,4.277-.525,4.272-.524,6.3,2.918-1.132,1.977-1.134,1.98-8.56,1.05-6.3-2.914Zm40.84-1.319-2.269,3.963-4.277.525-4.272.524-6.3-2.918,1.132-1.978,1.134-1.98,8.56-1.05ZM185.4,65.6l-1.132,1.977-1.134,1.98-8.56,1.05-6.3-2.914,2.269-3.963,4.277-.525,4.272-.524Zm-6.345-3-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.561-1.05,6.274,2.9Zm13.225-9.034-2.269,3.963-4.277.525-4.272.524L175.18,55.67l2.266-3.957,8.56-1.05Zm-4.076-6.954-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.962,4.277-.525,4.272-.524Zm-4.055-6.952-2.269,3.963-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.561-1.05Zm-6.341-3-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm13.225-9.034-2.269,3.963-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.283-.525ZM172.15,18.813l8.537-1.047,6.3,2.914-2.27,3.965-4.283.525-4.272.524-6.283-2.908Zm-.2-.018-2.269,3.963-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.283-.526ZM153.053,9.98,161.6,8.931l6.3,2.914-2.27,3.965-4.283.525-4.272.524-6.29-2.912Zm-.192-.02-2.269,3.963-8.56,1.05-6.282-2.908L138.018,8.1l4.277-.525,4.283-.526ZM133.94,1.143,142.506.093l6.3,2.914-2.27,3.965-4.283.525-4.272.524-6.3-2.918ZM122.984,6.215l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918Zm-10.956,5.071,8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918Zm-10.956,5.072,8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM90.117,21.429l8.555-1.05,6.3,2.916L102.7,27.258l-4.277.525-4.272.524-6.3-2.918ZM79.161,26.5l8.555-1.049,6.3,2.916L91.747,32.33l-4.277.525-4.272.524-6.3-2.918ZM68.205,31.572l8.555-1.05,6.3,2.916L80.791,37.4l-4.277.525-4.271.524-6.3-2.918ZM57.249,36.643,65.8,35.594l6.3,2.916-2.269,3.963L65.558,43l-4.272.524-6.3-2.918ZM46.294,41.714l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.271.524-6.3-2.918ZM35.338,46.786l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM24.382,51.857l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.271.524-6.3-2.918ZM13.426,56.929l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM.2,65.965,2.47,62l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525L6.5,68.879Zm18.916,8.826-8.548,1.049-6.3-2.914L6.543,68.96l4.283-.525L15.1,67.91l6.29,2.912Zm.192.019,2.269-3.963,8.561-1.05,6.282,2.908L34.15,76.668l-4.277.525-4.283.526ZM38.2,83.63l-8.537,1.047-6.3-2.914L25.637,77.8l4.283-.526,4.272-.524,6.283,2.908ZM53.237,85.5l-4.278.525-4.283.525-6.274-2.9,2.269-3.963,8.561-1.05,6.274,2.9Zm15.014,1.876-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm15.028,1.888L79,89.791l-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm15.014,1.875-8.56,1.05-6.275-2.9,2.269-3.963L90,84.8l4.272-.524,6.283,2.908Zm10.956-5.071-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm15.028,1.888L120,88.483l-4.272.524L109.445,86.1l2.266-3.958,8.56-1.05,6.275,2.9Zm16.169-.1-1.134,1.98-8.56,1.05-6.3-2.914,2.269-3.963L131,83.492l4.272-.524,6.3,2.918Zm9.822-3.091-8.561,1.05-6.3-2.914,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918L151.4,82.792ZM165.3,86.66l-4.277.525-4.272.524-6.3-2.918,1.132-1.977,1.134-1.98,8.56-1.05,6.3,2.914Zm15.034,1.888L171.775,89.6l-6.3-2.916,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918Z",
    transform: "translate(82.102 33.103)",
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M193,80.482l-1.715,3-8.555,1.049-6.3-2.916,2.269-3.963,4.278-.525,4.271-.524L193,79.261v-.124l-5.613-2.6,2.269-3.963,3.345-.41V72.08l-3.386.415-6.3-2.918,1.132-1.977,1.134-1.98L193,64.709V64.62l-7.47.916-6.3-2.914L181.5,58.66l4.277-.525,4.271-.524L193,58.976v-.124l-2.81-1.3,2.269-3.963.541-.066v-.086l-.582.071L186.135,50.6l2.266-3.958,4.6-.564v-.1l-4.666.573-6.274-2.9,2.269-3.962,4.277-.525,4.272-.524.122.056v-.423l-.163.286-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05L193,33.615v-.124l-4.039-1.87,2.275-3.973L193,27.432v-.086l-1.84.226-6.274-2.9,2.3-4.012-6.443-2.982-8.666,1.063-6.275-2.9,2.3-4.011-6.443-2.982L152.987,9.9l-6.282-2.908L149,2.982,142.559,0l-8.766,1.075-2.3,4.009-8.66,1.063-2.3,4.009-8.66,1.062-2.3,4.009-8.66,1.063L98.63,20.3l-8.66,1.063-2.3,4.009-8.66,1.063-2.3,4.009L68.058,31.5l-2.3,4.009L57.1,36.575l-2.3,4.009-8.661,1.063-2.3,4.009-8.66,1.063-2.3,4.009-8.661,1.063L21.94,55.8l-8.66,1.063-2.3,4.009L2.323,61.932,0,65.99l6.369,2.948-2.3,4.011,6.443,2.982,8.666-1.063,6.282,2.908-2.3,4.011,6.443,2.982,8.666-1.063,6.275,2.9-2.3,4.011L45.8,92.267h.253L42.452,90.6l2.271-3.965,4.283-.526,4.272-.524,6.283,2.908L57.4,92.267h.213l2.145-3.746,8.561-1.05,6.274,2.9-1.083,1.892H73.7L74.771,90.4l4.277-.525,4.272-.524L89.6,92.255l-.007.012h.343l8.42-1.033,2.231,1.033h.268l-2.37-1.1,2.266-3.957,8.561-1.05,6.274,2.9-1.832,3.2h.191l1.82-3.179,4.277-.525,4.272-.524,6.3,2.918-.75,1.31h.186l.739-1.29,8.56-1.05,5.057,2.341h.268l-5.195-2.4,1.132-1.977,1.134-1.98,8.561-1.05,6.3,2.914-2.269,3.963-4.277.525-.086.011h.7l3.7-.454.981.454h.267l-1.111-.514,2.269-3.963,4.278-.525,4.271-.524,6.3,2.918-1.493,2.608h.186l1.482-2.588,8.66-1.063,2.3-4.009,8.661-1.063L193,80.806Zm-16.748,1.107-4.278.525-4.271.524-6.3-2.918,1.132-1.977,1.134-1.98,8.561-1.05,6.3,2.914ZM121.24,51.112l-2.269,3.963-4.278.525-4.271.524-6.283-2.908,2.266-3.958,8.561-1.05ZM115.1,48.144l2.266-3.957,8.56-1.05,6.275,2.9L129.927,50l-4.277.525-4.272.524Zm-4.811,8.04-2.269,3.963-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.56-1.05Zm.179.021,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.051-6.275-2.9Zm8.687-1.109,2.269-3.963,4.277-.525,4.271-.524,6.283,2.908-2.266,3.958L125.425,58Zm10.956-5.072,2.269-3.962,4.277-.525,4.272-.524,6.283,2.908-2.266,3.958-8.56,1.05Zm10.777-5.092-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.561-1.05,6.274,2.9Zm-4.072-6.96-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.271-.524,6.283,2.908Zm-8.69,1.114-2.266,3.958-8.56,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524Zm-10.956,5.072L114.9,48.115l-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.271-.524Zm-10.956,5.071-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM95.253,54.3l-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM84.3,59.371l-2.266,3.957-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524ZM73.342,64.443,71.076,68.4l-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524Zm.2.029,8.56-1.05,6.275,2.9L86.1,70.288l-4.277.525-4.272.524-6.283-2.908Zm8.69-1.114L84.494,59.4l8.561-1.05,6.274,2.9L97.06,65.217l-4.277.525-4.272.524Zm17.28-2.082,4.277-.525,4.272-.524,6.283,2.908-2.266,3.958-8.561,1.05-6.274-2.9Zm15.028,1.888,8.56-1.05,6.274,2.9L127.1,68.981l-4.277.525-4.272.524-6.283-2.908Zm8.69-1.114,2.266-3.958,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524Zm17.28-2.082,4.278-.525,4.271-.524,6.283,2.908-2.266,3.958-8.561,1.05-6.274-2.9Zm8.508-1.13-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm-3.876-6.931L147.4,47.95l8.561-1.05,6.274,2.9-2.269,3.962-4.277.525-4.272.524Zm10.76-5.1-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.271-.524,6.283,2.908Zm-4.058-6.947-4.277.525-4.272.524L137.007,38l2.266-3.957,8.56-1.05,6.275,2.9Zm-4.072-6.96-8.56,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525L135.159,27l-6.29-2.912,2.266-3.957,8.56-1.05,6.282,2.908Zm-8.687,1.109-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.56-1.05Zm-10.956,5.071L121.8,36.1l-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.56-1.05ZM113.11,37.205l-2.269,3.963-4.277.525-4.272.524L96,39.305l2.266-3.957,8.56-1.05Zm-10.956,5.071-2.269,3.963-4.278.525-4.271.524-6.29-2.912,2.266-3.957,8.56-1.05ZM91.2,47.348l-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.561-1.05ZM80.242,52.42l-2.269,3.963-4.277.525-4.272.524-6.29-2.912L65.4,50.562l8.56-1.05ZM69.286,57.491l-2.269,3.963-4.277.525-4.272.524-6.29-2.912,2.266-3.957L63,54.583ZM58.33,62.562l-2.269,3.963-4.277.525-4.272.524-6.29-2.912L43.488,60.7l8.561-1.05ZM47.554,67.655l4.277-.525,4.272-.524,6.283,2.908L60.12,73.471l-8.56,1.05-6.274-2.9Zm15.028,1.888,8.561-1.05,6.274,2.9L75.148,75.36l-4.277.525-4.272.524L60.316,73.5ZM77.6,71.418l4.277-.525,4.272-.524,6.283,2.908-2.266,3.957L81.6,78.285l-6.274-2.9Zm8.687-1.109,2.269-3.963,4.277-.525L97.1,65.3l6.283,2.908-2.266,3.958-8.56,1.05Zm17.3-2.074,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525L107.6,75.1l-6.283-2.908Zm15.014,1.875,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.561,1.05-6.274-2.9ZM127.281,69l2.269-3.963,4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.05Zm17.3-2.074,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524-6.283-2.908ZM159.592,68.8l4.278-.525,4.271-.524,6.3,2.918-1.132,1.977-1.134,1.98-8.561,1.05-6.3-2.914Zm8.508-1.13-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm-4.072-6.959-8.56,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-3.879-6.926,2.269-3.963L166.7,49.3l4.271-.524,6.283,2.908-2.266,3.957-8.561,1.05Zm10.777-5.092-4.277.525-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm-4.072-6.959-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.278.525-4.271.524-6.283-2.908,2.266-3.957,8.561-1.05,6.274,2.9Zm-3.876-6.931,2.266-3.957,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.272.524Zm-.2-.029-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm-4.058-6.947-4.277.525-4.272.524-6.29-2.912,2.266-3.957,8.561-1.05,6.282,2.908Zm-15.028-1.888-8.561,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524,6.29,2.912Zm-8.69,1.114-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM119.99,25.18l-2.266,3.957-8.561,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524Zm-10.956,5.071-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM98.079,35.322,95.813,39.28l-8.561,1.05L80.97,37.422l2.269-3.963,4.277-.525,4.272-.524ZM87.123,40.394l-2.266,3.957L76.3,45.4l-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM76.167,45.465,73.9,49.422l-8.56,1.05-6.282-2.908L61.327,43.6l4.277-.525,4.272-.524ZM65.211,50.536l-2.266,3.957-8.56,1.05L48.1,52.636l2.269-3.963,4.277-.525,4.271-.524ZM54.255,55.608l-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.272-.524ZM43.3,60.679l-2.266,3.957-8.56,1.05-6.282-2.908,2.269-3.963,4.277-.525,4.271-.524ZM32.344,65.751l-2.266,3.957-8.561,1.05L15.235,67.85,17.5,63.888l4.277-.525,4.272-.524Zm.189.025,8.56-1.05,6.282,2.908L45.106,71.6l-4.277.525-4.272.524-6.29-2.912Zm4.066,6.95,4.277-.525,4.272-.524,6.283,2.908-2.266,3.958L40.6,79.593l-6.274-2.9Zm15.028,1.888,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.272.524L49.36,78.572ZM66.64,76.489l4.277-.525,4.272-.524,6.283,2.908-2.266,3.957-8.56,1.05-6.274-2.9Zm15.028,1.888,8.56-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524L79.4,82.335Zm8.69-1.114,2.266-3.958,8.56-1.05,6.275,2.9-2.269,3.963-4.277.525-4.272.524Zm17.28-2.082,4.277-.525,4.272-.524,6.283,2.908L120.2,81l-8.56,1.05-6.275-2.9Zm15.028,1.888,8.561-1.05,6.274,2.9-2.269,3.963-4.277.525-4.271.524L120.4,81.027Zm8.69-1.114L133.622,72l8.56-1.05,6.274,2.9-2.269,3.963-4.277.525-4.272.524Zm17.28-2.082,4.277-.525,4.272-.524,6.3,2.918-1.132,1.977-1.134,1.98-8.56,1.05-6.3-2.914Zm40.84-1.319-2.269,3.963-4.277.525-4.272.524-6.3-2.918,1.132-1.978,1.134-1.98,8.56-1.05ZM185.4,65.6l-1.132,1.977-1.134,1.98-8.56,1.05-6.3-2.914,2.269-3.963,4.277-.525,4.272-.524Zm-6.345-3-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.561-1.05,6.274,2.9Zm13.225-9.034-2.269,3.963-4.277.525-4.272.524L175.18,55.67l2.266-3.957,8.56-1.05Zm-4.076-6.954-2.266,3.958-8.56,1.05-6.275-2.9,2.269-3.962,4.277-.525,4.272-.524Zm-4.055-6.952-2.269,3.963-4.277.525-4.272.524-6.283-2.908,2.266-3.957,8.561-1.05Zm-6.341-3-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm13.225-9.034-2.269,3.963-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.283-.525ZM172.15,18.813l8.537-1.047,6.3,2.914-2.27,3.965-4.283.525-4.272.524-6.283-2.908Zm-.2-.018-2.269,3.963-8.56,1.05-6.275-2.9,2.269-3.963,4.277-.525,4.283-.526ZM153.053,9.98,161.6,8.931l6.3,2.914-2.27,3.965-4.283.525-4.272.524-6.29-2.912Zm-.192-.02-2.269,3.963-8.56,1.05-6.282-2.908L138.018,8.1l4.277-.525,4.283-.526ZM133.94,1.143,142.506.093l6.3,2.914-2.27,3.965-4.283.525-4.272.524-6.3-2.918ZM122.984,6.215l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918Zm-10.956,5.071,8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918Zm-10.956,5.072,8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM90.117,21.429l8.555-1.05,6.3,2.916L102.7,27.258l-4.277.525-4.272.524-6.3-2.918ZM79.161,26.5l8.555-1.049,6.3,2.916L91.747,32.33l-4.277.525-4.272.524-6.3-2.918ZM68.205,31.572l8.555-1.05,6.3,2.916L80.791,37.4l-4.277.525-4.271.524-6.3-2.918ZM57.249,36.643,65.8,35.594l6.3,2.916-2.269,3.963L65.558,43l-4.272.524-6.3-2.918ZM46.294,41.714l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.271.524-6.3-2.918ZM35.338,46.786l8.555-1.05,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM24.382,51.857l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.271.524-6.3-2.918ZM13.426,56.929l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525-4.272.524-6.3-2.918ZM.2,65.965,2.47,62l8.555-1.049,6.3,2.916-2.269,3.963-4.277.525L6.5,68.879Zm18.916,8.826-8.548,1.049-6.3-2.914L6.543,68.96l4.283-.525L15.1,67.91l6.29,2.912Zm.192.019,2.269-3.963,8.561-1.05,6.282,2.908L34.15,76.668l-4.277.525-4.283.526ZM38.2,83.63l-8.537,1.047-6.3-2.914L25.637,77.8l4.283-.526,4.272-.524,6.283,2.908ZM53.237,85.5l-4.278.525-4.283.525-6.274-2.9,2.269-3.963,8.561-1.05,6.274,2.9Zm15.014,1.876-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm15.028,1.888L79,89.791l-4.272.524-6.283-2.908,2.266-3.958,8.56-1.05,6.275,2.9Zm15.014,1.875-8.56,1.05-6.275-2.9,2.269-3.963L90,84.8l4.272-.524,6.283,2.908Zm10.956-5.071-8.561,1.05-6.274-2.9,2.269-3.963,4.277-.525,4.272-.524,6.283,2.908Zm15.028,1.888L120,88.483l-4.272.524L109.445,86.1l2.266-3.958,8.56-1.05,6.275,2.9Zm16.169-.1-1.134,1.98-8.56,1.05-6.3-2.914,2.269-3.963L131,83.492l4.272-.524,6.3,2.918Zm9.822-3.091-8.561,1.05-6.3-2.914,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918L151.4,82.792ZM165.3,86.66l-4.277.525-4.272.524-6.3-2.918,1.132-1.977,1.134-1.98,8.56-1.05,6.3,2.914Zm15.034,1.888L171.775,89.6l-6.3-2.916,2.269-3.963,4.277-.525,4.272-.524,6.3,2.918Z",
    transform: "translate(82.102 33.103)",
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(170.826 103.411)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(166.909 96.399)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(155.953 101.471)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79625",
    "data-name": "Path 79625",
    d: "M3.343.011A4.079,4.079,0,0,1,7.2,3.35c.144,1.7-1.348,2.961-3.334,2.817A4.079,4.079,0,0,1,.01,2.828C-.134,1.128,1.358-.133,3.343.011Z",
    transform: "translate(182.793 110.76) rotate(-22.637)",
    fill: "url(#radial-gradient-7)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(196.951 100.163)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(209.625 106.153)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(167.369 81.525)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(221.637 71.103)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(198.669 111.225)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79626",
    "data-name": "Path 79626",
    d: "M2.879,0C4.528.061,5.913,1.76,5.972,3.8S4.744,7.435,3.095,7.376.061,5.617,0,3.581,1.231-.058,2.879,0Z",
    transform: "translate(220.315 106.413) rotate(-81.467)",
    fill: "url(#radial-gradient-13)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 3.703,
    cy: 2.969,
    rx: 3.703,
    ry: 2.969,
    transform: "translate(229.815 84.981)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(215.926 84.021)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(139.599 104.471)",
    fill: "url(#radial-gradient-16)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(232.102 111.821)",
    fill: "url(#radial-gradient-17)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(245.829 87.706)",
    fill: "url(#radial-gradient-17)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(188.821 117.009)",
    fill: "url(#radial-gradient-16)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(153.497 80.486)",
    fill: "url(#radial-gradient-20)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(234.987 92.753)",
    fill: "url(#radial-gradient-17)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(248.714 68.849)",
    fill: "url(#radial-gradient-17)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(176.601 96.238)",
    fill: "url(#radial-gradient-16)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(146.64 92.452)",
    fill: "url(#radial-gradient-16)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(161.08 109.285)",
    fill: "url(#radial-gradient-16)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(243.143 106.762)",
    fill: "url(#radial-gradient-17)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(151.762 69.53)",
    fill: "url(#radial-gradient-16)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 2.623,
    cy: 2.103,
    rx: 2.623,
    ry: 2.103,
    transform: "translate(158.202 56.885)",
    fill: "url(#radial-gradient-16)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/Footer BG.494eea2282644b69d3830f533c6a682f.svg";
export { ForwardRef as ReactComponent };